import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAvMpnxGBwF5ylmVYPFPYXM8o7TOjJ0lSw",
  authDomain: "agustin-8mooncafe.firebaseapp.com",
  databaseURL: "https://agustin-8mooncafe-default-rtdb.firebaseio.com",
  projectId: "agustin-8mooncafe",
  storageBucket: "agustin-8mooncafe.firebasestorage.app",
  messagingSenderId: "143829453906",
  appId: "1:143829453906:web:9ef285cfe6f83ac7c9e38b",
  measurementId: "G-NGYBX00X1T"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Use initializeFirestore to configure settings
// Added experimentalForceLongPolling to resolve connection timeouts ("Backend didn't respond")
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  experimentalForceLongPolling: true
});
export const analytics = getAnalytics(app);